<template>
  <div>
    <el-table
      :data="tableData"
      stripe
      height="280"
      :cell-style="{ padding: '3px' }"
      :header-cell-style="{ padding: '3px' }"
      style="width: 100%; font-size: 12px"
    >
      <!-- <el-table-column prop="purchaseName" label="采购方" width="130" align="center"></el-table-column> -->
      <el-table-column label="采购方" width="240" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.purchaseName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.purchaseName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="Brand" width="240" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.brandName"
            popper-class="tooltip-class"
            placement="top"
          >
            <div class="ellipsis-1">{{ scope.row.brandName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="SKU" width="240" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.skuName"
            popper-class="tooltip-class"
            placement="top"
          >
            <div class="ellipsis-1">{{ scope.row.skuName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="实际数量(标准)" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.oriQuantity | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="拆分后数量(标准)" width="150" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.actualQuantity | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="拆分后金额" width="120" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.actualAmount | NumberFormat(false) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="actualRate" label="实际比例" width="90" align="center"></el-table-column>
      <el-table-column label="RM" width="150" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.rmUserName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.rmUserName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="DM" width="150" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.dmUserName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.dmUserName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="MR" width="150" align="center">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="light"
            :visible-arrow="false"
            :content="scope.row.mrUserName"
            popper-class="tooltip-class"
            placement="top-start"
          >
            <div class="ellipsis-1">{{ scope.row.mrUserName }}</div>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      small
      layout="prev, pager, next, total"
      :total="total"
      :page-size="ipagination.pageSize"
      @current-change="handleTableChange"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {}
    },
    ipagination: {
      type: Object,
      default: () => {}
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {}
  },
  mounted() {},
  watch: {},
  methods: {
    handleTableChange(pagination) {
      this.$emit('change', pagination)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-pagination {
  width: 100%;
  overflow-x: auto;
  li {
    margin: 0 3px !important;
  }
  .btn-prev {
    margin: 0 3px !important;
  }
  .btn-next {
    margin: 0 3px !important;
  }
  .btn-quickprev {
    margin: 0px !important;
  }
  .btn-quicknext {
    margin: 0px !important;
  }
}
.ellipsis {
  display: -webkit-box;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.ellipsis-1 {
  white-space: normal;
  word-break: break-all;
  line-height: 1.4;
}
</style>

<style lang="less">
.tooltip-class {
  font-size: 12px;
  color: #606266;
  border: 1px solid #fff !important;
  box-shadow: 0 0 5px #ccc;
}
</style>
